module.exports = __webpack_public_path__ + "static/media/engranaje.2058e1d0.svg";